import React from 'react';
import '../../../css/Form.css';
import Select from 'react-select';
import ERPUtils from '../../../helper/Utils'

const CurrentAddress = (props) => {
	// used States:
	const {
		userDetails,
		onChangeHandler,
		ValidationError,
		// states,
		cities,
		SelectHandler,
		countries,
		requiredFields,
		getStateFromPincodeData
		// GenerateRemovePopup
	} = props;


	
	return (
		<div>
			<div className="formWrapper">
				<div className="row">
					{/* <div className="col-md-3">&nbsp;</div> */}
					<div className="col-xs-12">
						<h4 className="addressHeader">
							Current Address
						</h4>
					</div>
				</div>
			</div>
			<div className="formWrapper">
				<div className="row">
					<div className="col-md-3 col-xs-12">
						<label className="appFormLabel">
							Address Line1
						</label>
						<span className="requiredText">*</span>
					</div>
					<div className="col-md-5 col-xs-12">
						<input
							className={
								requiredFields.commonErrors[0].currentLine1ReqError ? (
									'form-control invalid z-depth-3'
								) : (
									'form-control z-depth-3'
								)
							}
							value={userDetails.currentLine1}
							name="currentLine1"
							type="text"
							onChange={onChangeHandler}
							maxLength="100"
						/>
						{requiredFields.commonErrors[0].currentLine1ReqError ? (
							<p className="ValidationError">
								<i className="fa fa-warning warningIcon" />Address Line1 cannot be empty
							</p>
						) : null}
					</div>
				</div>
			</div >
			<div className="formWrapper">
				<div className="row">
					<div className="col-md-3 col-xs-12">
						<label className="appFormLabel">
							Address Line2
						</label>
					</div>
					<div className="col-md-5 col-xs-12">
						<input
							className="form-control z-depth-3"
							value={userDetails.currentLine2}
							name="currentLine2"
							type="text"
							onChange={onChangeHandler}
							maxLength="100"
						/>
					</div>
				</div>
			</div >
			<div className="formWrapper">
				<div className="row">
					<div className="col-md-3 col-xs-12">
						<label className="appFormLabel">
							Country
						</label>
						<span className="requiredText">*</span>
					</div>
					<div className="col-md-5 col-xs-12">
						<Select
							className={
								requiredFields.commonErrors[0].currentCountryReqError ? (
									'invalid z-depth-3'
								) : (
									'z-depth-3'
								)
							}
							value={userDetails.currentCountry}
							options={countries}
							onChange={(selected) => SelectHandler(selected, 'currentCountry')}
						/>
						{requiredFields.commonErrors[0].currentCountryReqError ? (
							<p className="ValidationError">
								<i className="fa fa-warning warningIcon" />Country cannot be empty
							</p>
						) : null}
					</div>
				</div>
			</div >
			<div className="formWrapper">
				<div className="row">
					<div className="col-md-3 col-xs-12">
						<label className="appFormLabel">
							Zip / Postal Code
						</label>
						<span className="requiredText">*</span>
					</div>
					<div className="col-md-5 col-xs-12">
						<input
							className={
								ValidationError.currentPincodeError ||
									requiredFields.commonErrors[0].currentPincodeReqError ? (
									'form-control invalid z-depth-3'
								) : (
									'form-control z-depth-3'
								)
							}
							value={userDetails.currentPincode}
							name="currentPincode"
							type="text"
							onChange={(e) => onChangeHandler(e, userDetails?.currentCountry?.nationality === "Indian")}
							minLength="6"
							maxLength="20"
							disabled={ERPUtils.isNullorWhiteSpace(userDetails.currentCountry)}
							onKeyDown={ERPUtils.validateSpecialCharacterInput}
						/>
						{ValidationError.currentPincodeError ? (
							<p className="ValidationError">
								<i className="fa fa-warning warningIcon" />Please enter a valid pincode
							</p>
						) : null}
						{ValidationError.currentPincodeLengthError ? (
							<p className="ValidationError">
								<i className="fa fa-warning warningIcon" />Pincode must be six digit
							</p>
						) : null}
						{requiredFields.commonErrors[0].currentPincodeReqError ? (
							<p className="ValidationError">
								<i className="fa fa-warning warningIcon" />Pincode cannot be empty
							</p>
						) : null}
					</div>
				</div>
			</div >
			<div className="formWrapper">
				<div className="row">
					<div className="col-md-3 col-xs-12">
						<label className="appFormLabel">
							City
						</label>
							 
						<span className="requiredText">*</span>
					</div>
					<div className="col-md-5 col-xs-12">

						{((ERPUtils.isNullorWhiteSpace(cities) || cities.length === 0) && ERPUtils.isNullorWhiteSpace(userDetails.currentCity) &&
							!(userDetails?.currentCountry?.nationality === "Indian")) ? (
							<div style={{ display: 'inline' }}>
								<input
									className="form-control z-depth-3"
									value={userDetails.otherCurrCity}
									name="otherCurrCity"
									type="text"
									onChange={onChangeHandler}
									maxLength="50"
								/>
					
								{/* <i
									className="fa fa-times"
									style={{
										marginLeft: '5px',
										position: 'absolute',
										top: '12px',
										right: '-20px'
									}}
									onClick={() => GenerateRemovePopup('CurCityPopup')}
								/> */}
							</div>
						) : (
							<Select
								className={
									requiredFields.commonErrors[0].currentCityReqError ? (
										'invalid z-depth-3'
									) : (
										'z-depth-3'
									)
								}
								value={typeof (userDetails.currentCity) === 'object' ? userDetails.currentCity : ERPUtils.getSelect2ItemByID(cities, parseInt(userDetails.currentCity, 10))}
								options={cities}
								onChange={(selected) => SelectHandler(selected, 'currentCity')}
							/>
						)}
						{(requiredFields.commonErrors[0].currentCityReqError  ||  requiredFields.commonErrors[0].otherCurrCityReqError) ?(
							<p className="ValidationError">
								<i className="fa fa-warning warningIcon" />City cannot be empty
							</p>
						) : null}
					</div>
				</div>
			</div >
			<div className="formWrapper">
				<div className="row">
					<div className="col-md-3 col-xs-12">
						<label className="appFormLabel">
							State
						</label>

							 <span className="requiredText">*</span>
					</div>
					<div className="col-md-5 col-xs-12">
						{(ERPUtils.isNullorWhiteSpace(userDetails.currentState) && !(userDetails?.currentCountry?.nationality === "Indian")) ? (
							<div style={{ display: 'inline' }}>
								<input
									className="form-control z-depth-3"
									value={userDetails.otherCurrState}
									name="otherCurrState"
									type="text"
									onChange={onChangeHandler}
									maxLength="100"
								/>
								{/* <i
									className="fa fa-times"
									style={{
										marginLeft: '5px',
										position: 'absolute',
										top: '12px',
										right: '-20px'
									}}
									onClick={() => GenerateRemovePopup('currStatePopup')}
								/> */}
						
							</div>
						) : (
							<Select
								className={
									requiredFields.commonErrors[0].currentStateReqError ? (
										'invalid z-depth-3'
									) : (
										'z-depth-3'
									)
								}
								// options={states}
								value={typeof (userDetails.currentState) === 'object' ? userDetails.currentState : getStateFromPincodeData(cities, userDetails.currentState, userDetails.currentCity)}
								// onChange={(selected) => SelectHandler(selected, 'currentState')}
								isDisabled
							/>
						)}
						{requiredFields.commonErrors[0].currentStateReqError || requiredFields.commonErrors[0].otherCurrStateReqError  ? (
							<p className="ValidationError">
								<i className="fa fa-warning warningIcon" />State cannot be empty
							</p>
						) : null}
					</div>
				</div>
			</div >


		</div >
	);
};

export default CurrentAddress;